import { render, staticRenderFns } from "./RecommendHotelSwiper.vue?vue&type=template&id=655c650a&scoped=true"
import script from "./RecommendHotelSwiper.vue?vue&type=script&lang=js"
export * from "./RecommendHotelSwiper.vue?vue&type=script&lang=js"
import style0 from "./RecommendHotelSwiper.vue?vue&type=style&index=0&id=655c650a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c650a",
  null
  
)

export default component.exports